import { render, staticRenderFns } from "./VueQrReader.vue?vue&type=template&id=5b3a8166&scoped=true&shadow"
import script from "./VueQrReader.vue?vue&type=script&lang=js&shadow"
export * from "./VueQrReader.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./VueQrReader.vue?vue&type=style&index=0&id=5b3a8166&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b3a8166",
  null
  ,true
)

export default component.exports